export default {
  createdAt: 'Created At',
  lastModifiedAt: 'Last Modified At',
};
